import { Component } from 'react';
import ReactModal from '../../../components/Modal';
import { getData, updateData } from './query';
import DataTable from '../../../components/Datatable';
import { COLUMNS } from './keys';
import { getSortKeys, setAdditionalStyles } from '../../../helpers/table';
import Loading from '../../../components/Loading';

class AlertsModal extends Component {
    constructor() {
        super();
        this.urlParams = new URLSearchParams(window.location.search);
        this.id = this.urlParams.get('id');
        this.onSelect = this.onSelect.bind(this);
        this.onSave = this.onSave.bind(this);

        this.state = {
            selectedItems: [],
            data: [],
            saveLoading: false,
        };
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => {
            return item.email?.toLowerCase().includes(search.toLowerCase());
        });
    }

    async componentDidMount() {
        try {
            if (this.id) {
                this.setState({
                    isLoading: true,
                });
                const res = await getData(this.id);
                const data = await res.json();
                this.setState({
                    data: data.result,
                    isLoading: false,
                });
            }
        } catch (err) {
            this.setState({
                isLoading: false,
            });
            console.log(err);
        }
    }

    onSelect(email) {
        this.setState({
            data: this.state.data.map((item) => {
                if (item.email === email) {
                    return { ...item, is_active: !item.is_active };
                }
                return item;
            }),
        });
    }

    async onSave() {
        try {
            this.setState({
                saveLoading: true,
            });
            const res = await updateData(this.id, this.state.data);
            const data = await res.json();
            if (data.result === 'success') {
                this.props.onOpenMessage('success', 'User list updated successfully');
            } else {
                this.props.onOpenMessage('err', data.result);
            }
            this.props.onClose();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                saveLoading: false,
            });
        }
    }

    render() {
        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="width-sm"
                onClose={this.props.onClose}
            >
                <div className="alerts">
                    {this.state.isLoading ? (
                        <Loading />
                    ) : (
                        <DataTable
                            nodes={[
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                                ...this.state.data,
                            ]}
                            sortFns={getSortKeys(COLUMNS())}
                            COLUMNS={COLUMNS(this.onSelect)}
                            searchFunction={this.searchFunction}
                            onlyTable
                            header="Emails"
                            notUseDefaultStyle
                            onlyPagination
                            customEmptyMessage="There is no data"
                            uniqKey={'email'}
                            additionalStyles={setAdditionalStyles(COLUMNS())}
                        />
                    )}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                        <button
                            className="button button-filled button-primary width-sm btn d-flex gap-5 align-items-center justify-content-center"
                            style={{ lineHeight: 'unset', marginRight: '10px' }}
                            onClick={this.onSave}
                            disabled={this.state.saveLoading}
                        >
                            {this.state.saveLoading && <Loading onlyPreloader />}
                            Save
                        </button>
                        <button
                            type="button"
                            className="button button-outline button-primary width-sm btn"
                            onClick={this.props.onClose}
                            style={{ lineHeight: 'unset' }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default AlertsModal;
